import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import { Button, Drawer, Field, Input } from '@itds/elements/index.js';
import FormUtils from '@itds/utils/Form';

const Edit = ({ contact, onClose, onSave, show }) => {
  const [errors, setErrors] = useState([]);
  const [data, setData] = useState({
    id: null,
    first_name: '',
    last_name: '',
    email: '',
    phone: '',
    title: ''
  });

  useEffect(() => {
    const new_contact = contact || {};

    setData({
      id: new_contact.id,
      first_name: new_contact.first_name || '',
      last_name: new_contact.last_name || '',
      email: new_contact.email || '',
      phone: new_contact.phone || '',
      title: new_contact.title || ''
    });

    setErrors([]);
  }, [contact]);

  const handleInputChange = (name, e) => {
    setData({ ...data, [name]: e.target.value });
  };

  const handleSave = () => {
    const errors = [];

    if (!data.first_name) {
      errors.push('first_name');
    }

    if (!data.last_name) {
      errors.push('last_name');
    }

    if (data.email && !FormUtils._validateEmail(data.email)) {
      errors.push('email');
    }

    setErrors(errors);

    if (!errors.length) {
      onSave(data);
    }
  };

  return (
    <Drawer
      alignRight={true}
      footer={<Button onClick={handleSave}>{data.id ? 'Save Changes' : 'Create Contact'}</Button>}
      onClose={onClose}
      show={show}
      title={data.id ? 'Editing Contact' : 'New Contact'}
    >
      <Field label='First Name'>
        <Input
          invalid={errors.includes('first_name')}
          onChange={handleInputChange.bind(null, 'first_name')}
          required={true}
          value={data.first_name}
        />
      </Field>

      <Field label='Last Name'>
        <Input
          invalid={errors.includes('last_name')}
          onChange={handleInputChange.bind(null, 'last_name')}
          required={true}
          value={data.last_name}
        />
      </Field>

      <Field label='Email'>
        <Input onChange={handleInputChange.bind(null, 'email')} value={data.email} />
      </Field>

      <Field label='Phone'>
        <Input format='phone' onChange={handleInputChange.bind(null, 'phone')} value={data.phone} />
      </Field>

      <Field label='Title'>
        <Input onChange={handleInputChange.bind(null, 'title')} value={data.title} />
      </Field>
    </Drawer>
  );
};

Edit.propTypes = {
  contact: PropTypes.object,
  onClose: PropTypes.func,
  onSave: PropTypes.func,
  show: PropTypes.bool
};

export default Edit;
